import Superagent from 'superagent'
import Storage from './storage.service'
import Access from '../$methods/access.methods'

const { HOST_API } = _CONSTANTS_

export default {
    getZones,
    createZone,
    updateZone,
    deleteZone,
}

function getZones() {
    return request('get', `${HOST_API}/zones`)
}

function createZone(data) {
    return request('post', `${HOST_API}/zones`, data)
}

function updateZone(zoneId, data) {
    return request('put', `${HOST_API}/zones/${zoneId}`, data)
}

function deleteZone(zoneId) {
    return request('delete', `${HOST_API}/zones/${zoneId}`)
}

function request(method, url, data) {
    return new Promise((resolve) => {
        Superagent[method](url)
            .set('access', Storage.getItem('access'))
            .send(data)
            .end((err, res) => {
                const body = res && res.body
                    ? res.body
                    : { success: false, error: { message: 'No se pudo conectar con el servidor' } }
                Access(body)
                resolve(body)
            })
    })
}
